
import request from "@/request";
import { data } from "jquery";
const part_url = "recruit/web/choosePostRecruit/";

/**
 * 查询招聘公告列表
 *
 * @param {*} pageNow 页数
 * @param {*} pageSize 每页数量
 * @param {*} category 招聘类型
 * @returns
 */
function getChoosePostList(data) {
    let url = part_url + "getChoosePostList";
    return request.get(url, data);
}

/**
 * 查询招聘详情
 *
 * @param {*} id 招聘公告id
 * @returns
 */
function getChoosePostInfoById(data) {
    let url = part_url + "getChoosePostInfoById";
    return request.get(url, data);
}
/**
 * 查询我的报名
 *
 * @returns
 */
function getChoosePostSignList(data) {
    let url = "recruit/choosePostSign/getChoosePostSignList";
    return request.get(url, data);
}

function addSignInfo(data) {
    let url = "recruit/choosePostSign/addSignInfo";
    return request.post(url, {}, data)
}
function updateSignInfo(data) {
    let url = "recruit/choosePostSign/updateSignInfo";
    return request.post(url, {}, data)
}
function cancelSignInfo(data) {
    let url = "recruit/choosePostSign/cancelSignInfo";
    return request.get(url, data)
}
function getById(data) {
    let url = "recruit/choosePostSign/getById";
    return request.get(url, data)
}
function checkSign(data) {
    let url = "recruit/choosePostSign/checkSign";
    return request.get(url, data)
}

export default {
    getChoosePostList,
    getChoosePostInfoById,
    addSignInfo,
    updateSignInfo,
    getChoosePostSignList,
    cancelSignInfo,
    getById,
    checkSign
};


// WEBPACK FOOTER //
// ./src/api/choosePostRecruit.js